// The scoresheet while a puzzle hides the moves from its position on
// (Scoresheet visibility's `hideFrom`): instead of a long column of dots,
// the sheet is headed "How you got here", ends at the puzzle's move, which
// is drawn as a "?" in the accent, and one muted line says the rest is
// hidden. Pure; `Scoresheet.tsx` draws what this decides.
import type { SheetRow } from './rows.ts';

/** The panel's heading: the sheet's usual one, or the puzzle's. */
export function sheetHeading(concealFrom: number | undefined): string {
  return concealFrom === undefined ? 'Scoresheet' : 'How you got here';
}

/** The muted line under a capped sheet. */
export const HIDDEN_NOTE = 'The rest of the game is hidden until you solve it.';

/**
 * The rows to draw: all of them when nothing is concealed, else up to and
 * including the row that holds the move at `concealFrom`, the puzzle's
 * (its cell is the "?"). A `concealFrom` past the last move hides nothing.
 */
export function puzzleRows(rows: readonly SheetRow[], concealFrom: number | undefined): readonly SheetRow[] {
  if (concealFrom === undefined) return rows;
  const last = Math.floor(concealFrom / 2);
  return rows.slice(0, last + 1);
}

/** Whether a concealed cell is the puzzle's own move: the one drawn as "?". */
export function isAsked(index: number, concealFrom: number | undefined): boolean {
  return concealFrom !== undefined && index === concealFrom;
}
